import React from "react";
import VendorSubTabs from "../pages/Sales/Vendors/components/VendorSubTabs";
import { Outlet } from "react-router-dom";

const detailsArr = [
  {
    name: "Company Profile",
    link: "company-profile",
  },
  {
    name: "Company Preference",
    link: "company-preference",
  },
  {
    name: "Billing Terms",
    link: "billing-terms",
  },
  {
    name: "Description",
    link: "description",
  },
];

const VendorDetailsLayout = () => {
  return (
    <div>
      {/* Render the navigation tabs */}
      <div className="border-b border-stone-300 justify-start items-start inline-flex mt-5">
        {detailsArr.map(({ name, link }) => (
          <VendorSubTabs key={link} name={name} link={link} />
        ))}
      </div>

      {/* Render child routes here */}
      <Outlet />
    </div>
  );
};

export default VendorDetailsLayout;
